
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReceiptGrid extends Serenity.EntityGrid<ECommSalesReceiptRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReceipt'; }
        protected getDialogType() { return ECommSalesReceiptDialog; }
        protected getIdProperty() { return ECommSalesReceiptRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReceiptRow.localTextPrefix; }
        protected getService() { return ECommSalesReceiptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}